import { Box, Stack, Typography } from '@mui/material'
import { KomejirushiMongon } from '~/components/common/KomejirushiMongon'
import { FC } from 'react'
import { LinkToInfo } from '~/components/common/LinkToInfo'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'

export const FirstStep: FC = () => {
  return (
    <Stack spacing={0.5}>
      <KomejirushiMongon
        sx={{ mb: 2 }}
        text="既にFacebookアカウントをお持ちの方は、「次のステップへ」からお進みください。"
      />
      <Typography>Instagram連携のためには、Facebook認証が必要です。</Typography>
      <Typography>Facebookアカウントをお持ちでない方は、まずはFacebookアカウントを作成してください。</Typography>
      <LinkToInfo
        href={EXTERNAL_LINKS.FACEBOOK_ACCOUNT_CREATION}
        textBefore=""
        linkText="Facebookアカウントの作成"
      />

      <Box sx={{ pt: 2 }}>
        <LinkToInfo
          href={EXTERNAL_LINKS.FACEBOOK_PRIVACY_POLICY}
          textBefore="Meta社プライバシーポリシーは"
          linkText="こちら"
          variant="body2"
        />
      </Box>
    </Stack>
  )
}
